import api from './api';

const cashboxService = {
    getTransactions: async (params = {}) => {
        const response = await api.get('/company-cashbox/transactions', { params });
        return response.data;
    },

    getTransaction: async (id) => {
        const response = await api.get(`/company-cashbox/transactions/${id}`);
        return response.data;
    },

    getTransactionDetails: async (id) => {
        const response = await api.get(`/company-cashbox/transactions/${id}/details`);
        return response.data;
    },

    createTransaction: async (transactionData) => {
        const response = await api.post('/company-cashbox/transactions', transactionData);
        return response.data;
    },

    updateTransaction: async (id, transactionData) => {
        const response = await api.put(`/company-cashbox/transactions/${id}`, transactionData);
        return response.data;
    },

    deleteTransaction: async (id) => {
        const response = await api.delete(`/company-cashbox/transactions/${id}`);
        return response.data;
    },

    getStats: async (params = {}) => {
        const response = await api.get('/company-cashbox/stats', { params });
        return response.data;
    },

    getCategories: async (params = {}) => {
        const response = await api.get('/company-cashbox/categories', { params });
        return response.data;
    },

    getMonthlyReport: async (params = {}) => {
        const response = await api.get('/company-cashbox/report/monthly', { params });
        return response.data;
    },

    getBalance: async () => {
        const response = await api.get('/company-cashbox/balance');
        return response.data;
    },

    recalculateBalance: async () => {
        const response = await api.post('/company-cashbox/recalculate');
        return response.data;
    },

    syncPayslips: async () => {
        const response = await api.post('/company-cashbox/sync-payslips');
        return response.data;
    }
};

export default cashboxService;
